unit UMain;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.DBCtrls, Data.DB, WEBLib.DB, XData.Web.Client, XData.Web.Connection,
  XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.Toast, WEBLib.Grids,
  Vcl.Grids, ULogin;

type
  TForm1 = class(TWebForm)
    WebButton1: TWebButton;
    btnSearch: TWebButton;
    edtLaundrySearchID: TWebEdit;
    mmTest: TWebMemo;
    edtEmptyBack: TWebEdit;
    edtDirty: TWebEdit;
    edtEmptyNeeded: TWebEdit;
    lblMain: TWebLabel;
    lblDirty: TWebLabel;
    lblEmptyNeeded: TWebLabel;
    lblEmptyBack: TWebLabel;
    dtpCreated: TWebDateTimePicker;
    dtpModified: TWebDateTimePicker;
    lblCreated: TWebLabel;
    lblModified: TWebLabel;
    mmComment: TWebMemo;
    lblUserID: TWebLabel;
    lblDeliveryID: TWebLabel;
    lblCustomerID: TWebLabel;
    lblComment: TWebLabel;
    edtUserID: TWebEdit;
    edtDeliveryID: TWebEdit;
    edtCustomerID: TWebEdit;
    btnUpdate: TWebButton;
    btnClearAll: TWebButton;
    btnCreate: TWebButton;
    WebDateTimePicker1: TWebDateTimePicker;
    WebButton2: TWebButton;
    edtCreated: TWebEdit;
    edtModified: TWebEdit;
    btnDelete: TWebButton;
    WebToast1: TWebToast;
    WebDBGrid1: TWebDBGrid;
    WebDBEdit1: TWebDBEdit;
    procedure WebFormCreate(Sender: TObject);
    procedure btnSearchClick(Sender: TObject);
    procedure XDataWebClient1Load(Response: TXDataClientResponse);
    procedure btnUpdateClick(Sender: TObject);
    procedure btnClearAllClick(Sender: TObject);
    procedure btnCreateClick(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure btnDeleteClick(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  end;

var
  Form1: TForm1;

implementation

{$R *.dfm}

uses
  DateUtils, UDatamodule;//  Laundry;

procedure TForm1.btnClearAllClick(Sender: TObject);
var
  i: integer;
begin
  for i := 0 to componentcount - 1 do
  begin
    if (components[i] is TwebEdit) or (components[i] is TWebMemo) then
    begin
      TWebEdit(components[i]).Clear;
      TWebMemo(components[i]).Clear;
    end;
  end;
end;

procedure TForm1.btnCreateClick(Sender: TObject);
var
  param: JS.TJSObject;
// JSON String
//    '{ '+
//      '"LaundryID": 0,'+
//      '"UserID": 0,'+
//      '"DeliveryID": 0,'+
//      '"CustomerID": 0,'+
//      '"Comment": "string",'+
//      '"Created": "",'+
//      '"Modified": "",'+
//      '"Dirty": 0,'+
//      '"EmptyNeeded": 0,'+
//      '"EmptyBack": 0'+
//     '}');

  procedure onResult(Response: TXDataClientResponse);
  begin
  // is this even needed? probably no
    UDM.XDataWebDataSet_Laundry.Close;
    UDM.XDataWebDataSet_Laundry.Open;
  end;
begin
  param := TJSJson.parseObject('{ '+
    '"LaundryID": 0,'+
    '"UserID": '+edtUserID.Text+','+
    '"DeliveryID": '+edtDeliveryID.Text+','+
    '"CustomerID": '+edtCustomerID.Text+','+
    // dates cause issues in parsing so handled on server
   // '"Created": "'+DateTimeToStr(now)+'",'+
   // '"Modified": "'+DateTimeToStr(now)+'",'+
    '"Comment": "'+mmComment.Lines.Text+'",'+
    '"Dirty": '+edtDirty.Text+','+
    '"EmptyNeeded": '+edtEmptyNeeded.Text+','+
    '"EmptyBack": '+edtEmptyBack.Text+
    ' }');
    UDM.XDataWebClient.RawInvoke('ILaundry.CreateLaundry', [param], @onResult);
end;

procedure TForm1.btnSearchClick(Sender: TObject);
begin
  mmTest.Clear;
  mmComment.Clear;
  UDM.XDataWebClient.RawInvoke('ILaundry.GetLaundry', [StrToInt(edtLaundrySearchID.Text)],
    procedure(Response: TXDataClientResponse)
    begin
      UDM.XDataWebDataSet_Laundry.Close;
      mmTest.Lines.Add((Response.ResponseText));
      edtDirty.Text := String(TJSObject(Response.Result)['Dirty']);
      edtEmptyNeeded.Text := String(TJSObject(Response.Result)['EmptyNeeded']);
      edtEmptyBack.Text := String(TJSObject(Response.Result)['EmptyBack']);
      // hidden controls
//      dtpCreated.DateTime := TJSObject(Response.Result)['Created'];
//      dtpModified.DateTime := TJSObject(Response.Result)['Modified'];
      edtCreated.Text := String(TJSObject(Response.Result)['Created']);
      edtModified.Text := String(TJSObject(Response.Result)['Modified']);
      edtUserID.Text := String(TJSObject(Response.Result)['UserID']);
      edtDeliveryID.Text := String(TJSObject(Response.Result)['DeliveryID']);
      edtCustomerID.Text := String(TJSObject(Response.Result)['CustomerID']);
      mmComment.Lines.Add(String(TJSObject(Response.Result)['Comment']));
      UDM.XDataWebDataSet_Laundry.Open;
    end
  );
end;

procedure TForm1.btnUpdateClick(Sender: TObject);
var
  param: JS.TJSObject;

  procedure onResult(Response: TXDataClientResponse);
  begin
    UDM.XDataWebDataSet_Laundry.Close;
    UDM.XDataWebDataSet_Laundry.Open;
  end;
begin
  param := TJSJson.parseObject('{'+
    '"UserID": '+edtUserID.Text+','+
    '"DeliveryID": '+edtDeliveryID.Text+','+
    '"CustomerID": '+edtCustomerID.Text+','+
    '"Comment": "'+mmComment.Lines.Text+'",'+
    '"Dirty": '+edtDirty.Text+',      '+
    '"EmptyNeeded": '+edtEmptyNeeded.Text+','+
    '"EmptyBack": '+edtEmptyBack.Text+
    ' }');

  UDM.XDataWebClient.RawInvoke('ILaundry.UpdateLaundry', [StrToInt(edtLaundrySearchID.Text), param], @onResult);
end;

procedure TForm1.WebButton2Click(Sender: TObject);
begin
  //WebDateTimePicker1.DateTime := StrToDateTime('2024/08/20 09:59:48');
end;

procedure TForm1.btnDeleteClick(Sender: TObject);
begin
  //Response := await(Xdatawebclient1.RawInvokeAsync('ILaundry.DeleteLaundry', [StrToInt(edtLaundrySearchID.Text)]));
    UDM.Xdatawebclient.RawInvoke('ILaundry.DeleteLaundry', [StrToInt(edtLaundrySearchID.Text)]);
end;

procedure TForm1.WebFormCreate(Sender: TObject);
begin
  UDM.XDataWebConnection.Connected := True;
  mmTest.Clear;
  mmComment.Clear;
  //WebToast1.Items.Items[0].Show;
end;

procedure TForm1.XDataWebClient1Load(Response: TXDataClientResponse);
begin
//  Webmemo1.Lines.Add((Response.ResponseText));
end;

end.